import { useEffect } from "react"
import styled from "styled-components"
import equipe from "./../assets/equipe.jpg"
import client from "./../assets/client.jpg"
import team from "./../assets/team.jpg"
import colors from "../utils/colors";
import { Link } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import { servicesData } from "../datas/services"

const ServiceSection = styled.section`
    padding: 4rem clamp(1rem, 4vw, 4rem);
    background: ${colors.lightBackground};
`;

const Title = styled.h1`
    position: relative;
    padding: 0 1rem 1.5rem;
    margin: 0 auto 1rem;
    text-align: center;
    font-size: clamp(2.1rem, 4vw, 3rem);
    color: ${colors.primaryColor};
    line-height: 1.1;
    
    span {
        color: ${colors.background};
    }

    hr {
        width: 5rem;
        height: 0.24rem;
        margin: 1rem auto 0;
        border: none;
        border-radius: 999px;
        background-color: ${colors.primaryColor};
    }

    @media screen and (max-width:770px) {
        font-size: 2.6rem;
    }
`;

const ServicesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.5rem;
    align-items: stretch;
    max-width: 1180px;
    margin: 0 auto;

    @media screen and (max-width:770px) {
        grid-template-columns: 1fr;
        gap: 1rem;
    }
`;

const Service = styled.div`
    width: 100%;
    margin: 0;
    border-radius: 0.9rem;
    overflow: hidden;
    background: ${colors.textColor};
    box-shadow: 0 1rem 2rem rgba(69, 90, 100, 0.14);
    transition: all 0.3s ease-out;

    &:hover:before {
        opacity: 0.8;
    }

    &:hover {
        transform: translateY(-0.4rem);
    }
`;

const ServiceImg = styled.div`
    img {
        width: 100%;
        height: 12rem;
        object-fit: cover;

        @media screen and (max-width:770px) {
            height: 13rem;
        }
    }
`;

const ServiceContent = styled.div`
    background-color: ${colors.textColor};
    width: 100%;
    min-height: 12rem;
    text-align: center;
    padding: 1.2rem 1rem 1.4rem;

    @media screen and (max-width:770px) {
        min-height: auto;
    }
`;

const ServiceTitle = styled.h5`
    margin-bottom: 0.8rem;
    font-size: 1.25rem;
    color: ${colors.background};
    line-height: 1.2;

    @media screen and (max-width:770px) {
        font-size: 1rem;
    }
`;

const ServiceText = styled.p`
    margin-bottom: 1.2rem;
    padding: 0;
    font-size: 0.9rem;
    min-height: 3.4rem;
    text-align: center;
    color: ${colors.darkColor};
    overflow: hidden;

    @media screen and (max-width:770px) {
        text-align: center;
        font-size: 0.7rem;
    }
`;

const ServiceLink = styled(Link)`
    display: inline-block;
    background-color: ${colors.background};
    color: ${colors.textColor};
    padding: 0.55rem 1.15rem;
    border-radius: 2rem;
    text-decoration: none;
    font-size: 0.95rem;
    box-shadow: 0 0.6rem 1.1rem rgba(26, 35, 126, 0.18);
    transition: background-color 0.25s ease, transform 0.25s ease;

    &:hover {
        background-color: ${colors.secondColor};
        transform: translateY(-0.1rem);
    }
`;

const ServiceMoreLink = styled(Link)`
    display: inline-block;
    background-color: ${colors.background};
    color: ${colors.textColor};
    padding: 0.8rem 1rem;
    border-radius: 999px;
    text-decoration: none;
    justify-self: end;
    grid-column: 1 / -1;
    box-shadow: 0 0.7rem 1.2rem rgba(26, 35, 126, 0.18);
    transition: background-color 0.25s ease, transform 0.25s ease;
    &:hover {
        background-color: ${colors.secondColor};
        transform: translateX(0.2rem);
    }
    i{
        text-align: center;
    }
`;

const ReasonSection = styled.section`
    padding: 4rem clamp(1rem, 4vw, 4rem);
    background: ${colors.textColor};

    @media screen and (max-width:770px) {
        padding: 3rem 1rem;
    }
`;

const ReasonContainers = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.5rem;
    justify-content: center;
    align-items: center;
    max-width: 1180px;
    margin: 0 auto;
    padding: 2rem; 
    background-color: ${colors.lightBackground};
    border-radius: 1rem;
    box-shadow: inset 0 0 0 1px rgba(69, 90, 100, 0.08);

    @media screen and (max-width:770px) {
        grid-template-columns: 1fr;
        text-align: center;
        padding: 1rem;
        margin-bottom: 0;
    }
    
    @media screen and (max-width:400px) {
        padding: 0.8rem;
    }
`;

const ReasonTitle = styled.h1`
    margin: 0;
    font-size: clamp(1.5rem, 3vw, 2.4rem);
    color: ${colors.background};
    line-height: 1.2;

    p {     
        margin-top: 1rem;  
        line-height: 1.5;
        font-size: 1rem;
        width: 100%;
        color: ${colors.darkColor};
        font-weight: 500;
    }

    @media screen and (max-width:770px) {
        font-size: 2rem;
        margin: 2rem 0;
        text-align: left;
        
        p{
            margin: 0;
            text-align: center;
        }
    }
`;

const ReasonImg = styled.img`
    margin: 0;
    width: 100%;
    height: 20rem;
    object-fit: cover;
    border-radius: 0.8rem;
    box-shadow: 0 1rem 2rem rgba(69, 90, 100, 0.16);

    @media screen and (max-width:770px) {
        height: 15rem;
    }
`;


const AboutSection = styled.section`
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: ${colors.background};
    min-height : 28rem;
    padding: 0 clamp(1rem, 4vw, 4rem);
    color: ${colors.textColor};
    overflow: hidden;

    @media screen and (max-width:770px) {
        flex-direction: column;
        min-height: auto;
        padding: 2rem 1rem;
        gap: 1.5rem;
    }
`;

const Image = styled.img`
    width: min(45%, 38rem);
    height: 28rem;
    object-fit: cover;
    border-radius: 0 0 1rem 1rem;
    
    @media screen and (max-width:770px) {
        width: 100%;
        height: 16rem;
        border-radius: 0.8rem;
    }

    @media screen and (max-width:400px) {
        font-size: 10rem;
    }
`;

const Content = styled.div`
    flex: 1;
    max-width: 36rem;
    margin-left: 2rem; 

    @media screen and (max-width:770px) {
        margin-left: 0;
    }
`;

const AboutTitle = styled.h2`
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 0.8rem;
    color: ${colors.primaryColor};

    @media screen and (max-width:770px) {
        font-size: 1.1rem;
    }

    @media screen and (max-width:400px) {
        font-size: 0.8rem;
    }
    `;
    
    const Text = styled.p`
    font-size: 1.2rem;
    line-height: 1.6;
    margin-bottom: 1.8rem;
    color: ${colors.textColor};

    @media screen and (max-width:770px) {
        font-size: 0.6rem;
        text-wrap: wrap;
    }

    @media screen and (max-width:400px) {
        font-size: 0.4rem;
    }
    `;
    
const List = styled.ul`
    margin-bottom: 1.8rem;
    margin-left: 2rem;
    color: ${colors.textColor};
    
    @media screen and (max-width:770px) {
        margin-left: 1rem;
    }

    @media screen and (max-width:400px) {
        font-size: 0.8rem;
    }
`;

const ListItem = styled.li`
    font-size: 1.2rem;
    margin-bottom: 0.2rem;

    @media screen and (max-width:770px) {
        font-size: 0.8rem;
    }

    @media screen and (max-width:400px) {
        font-size: 0.6rem;
    }
`;

const Button = styled(Link)`
    padding: 10px 20px;
    background-color: ${colors.textColor};
    color: ${colors.darkBackground};
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: bold;
    border-radius: 999px;
    transition: background-color 0.3s ease, color 0.3s ease;

    &:hover {
        background-color: ${colors.secondColor};
        color: ${colors.textColor};
    }

    @media screen and (max-width:770px) {
        font-size: 0.7rem;
        padding: 5px 10px;
    }
    
    @media screen and (max-width:400px) {
        font-size: 0.5rem;
        padding: 4px 8px;
    }
`;

function Main() {
    useEffect(() => {
        Aos.init({duration: 250});
    }, []);

    return (
        <>
            <ServiceSection>
                <Title>
                    Nos <span>Activités</span> <hr />
                </Title>
                <ServicesContainer>
                    <Service>
                        <ServiceImg>
                            <img src={servicesData[0].image} alt="" />
                        </ServiceImg>
                        <ServiceContent>
                        <ServiceTitle>{servicesData[0].title}</ServiceTitle>
                            <ServiceText>{servicesData[0].description}</ServiceText>
                            <ServiceLink to={`/Services/${encodeURIComponent(servicesData[0].title)}`}>Plus</ServiceLink>
                        </ServiceContent>
                    </Service>
                    <Service>
                        <ServiceImg>
                            <img src={servicesData[1].image} alt="" />
                        </ServiceImg>
                        <ServiceContent>
                            <ServiceTitle>{servicesData[1].title}</ServiceTitle>
                            <ServiceText>{servicesData[1].description}</ServiceText>
                            <ServiceLink to={`/Services/${encodeURIComponent(servicesData[1].title)}`}>Plus</ServiceLink>
                        </ServiceContent>
                    </Service>
                    <Service>
                        <ServiceImg>
                            <img src={servicesData[2].image} alt="" />
                        </ServiceImg>
                        <ServiceContent>
                            <ServiceTitle>{servicesData[2].title}</ServiceTitle>
                            <ServiceText>{servicesData[2].description}</ServiceText>
                            <ServiceLink to={`/Services/${encodeURIComponent(servicesData[2].title)}`}>Plus</ServiceLink>
                        </ServiceContent>
                    </Service>
                    <ServiceMoreLink to="/Services"><i className="bi bi-arrow-right"></i></ServiceMoreLink>
                </ServicesContainer>
            </ServiceSection>
            <AboutSection>
                <Image src={team} alt="Description de l'image" />
                <Content>
                    <AboutTitle>Qui sommes nous</AboutTitle>
                    <Text>
                        Société de prestation de multi-services, offrant une gamme complète de solutions pour répondre à vos besoins
                    </Text>
                    <List>
                        <ListItem>Polyvalence</ListItem>
                        <ListItem>Fiabilité </ListItem>
                        <ListItem>Souplesse</ListItem>
                        <ListItem>Fiabilité </ListItem>
                    </List>
                    <Button to="/Apropos">En savoir plus</Button>
                </Content>
            </AboutSection>
            <ReasonSection>
                <Title>
                    Pourquoi <span>nous choisir ?</span> <hr />
                </Title>
                <ReasonContainers>
                    <ReasonTitle data-aos="fade-left" data-aos-offset="400">
                        Equipe dynamique et compétente <br />
                        <p>
                            Une offre diversifiée couvrant plusieurs domaines pour répondre à tous vos besoins <br />
                            Des prestations de qualité assurées par une équipe compétente et expérimentée
                        </p>
                    </ReasonTitle>
                    <ReasonImg data-aos="zoom-out-right" data-aos-offset="300" src={equipe} alt="équipe"/>
                    <ReasonImg data-aos="zoom-out-left" data-aos-offset="200" src={client} alt="clients"/>
                    <ReasonTitle data-aos="fade-right" data-aos-offset="100">
                        Plusieurs clients satisfaits <br />
                        <p>
                            Des solutions sur mesure adaptées à vos exigences spécifiques et évolutives <br />
                            Un partenariat solide et un service client attentif pour garantir votre satisfaction à chaque étape
                        </p>
                    </ReasonTitle>
                </ReasonContainers>
            </ReasonSection> 
        </>
    )
}

export default Main
